module.exports = __webpack_public_path__ + "assets/img/on2-336f7fb6.png";